<div class="card-container mat-elevation-z1">
  <div class="card-content">
      <clinic-history-control-component [patientid]="patientId"></clinic-history-control-component>
  </div>
</div>
